import { API } from '@api/api'
import { queryKeys } from '@api/queryKeys'
import type { CompanyConfigDto } from '@api/types/procurement'
import { skipToken, useQuery } from '@tanstack/react-query'

export const useCompanyConfigForProcurement = (companyId: number | undefined) =>
  useQuery<CompanyConfigDto | null, Error>({
    queryKey: [queryKeys.procurement.config.fetchCompanyConfig.toKey(), companyId],
    queryFn: companyId
      ? async () => {
          try {
            return await API.procurements.fetchCompanyConfig({
              companyId: companyId,
            })
          } catch (error) {
            if (error && typeof error === 'object' && 'status' in error && error.status === 404) {
              return null
            }
            console.error('Error fetching company config from procurement service:', error)
            throw error
          }
        }
      : skipToken,
  })
